import React, { useState } from 'react';
import { DropdownButton, Dropdown} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';


const Dropdown_tutor = (props) => {

    const [value1, setValue1] = useState('');


    const handleSelect = (item_id) => {
      
        console.log('assegnazione alla classe')
       
        axios.put('/classi/aggiungi_tutor_alla_classe/' + props.classe._id + '/' + item_id) 
        .then((res) => {
//      console.log('Aggiunta una classe')
//        console.log(res.data)
        }).catch((error) => {
        console.log(error)
});
        props.SET_variab_aggiorna(current => !current)
     
    }


    function displayStarRating() {
        var stringa
        const btn = { color: "red", margin: "5%", boxShadow: "5px 5px 3px rgba(46, 46, 46, 0.62)" }
        return btn;
    }


    function Inserisci_materia_attuale() {
        let btn = "..."
        if (props.alunno.classe_id === undefined) {return btn}
        btn = props.alunno.classe_id.nome 
        return btn
    }
    /* idroslab  dropdown scelta in base ad eventkey*/

    return (
     
        <DropdownButton
            variant="primary"
            title={'Assegna tutor'}
            onSelect={handleSelect} >
            {props.lista_tutor.map(function (item1, index2) {
                {
                    return <div>
                        <Dropdown.Item eventKey={item1._id}> {item1.cognome} &nbsp; {item1.nome} </Dropdown.Item>
                    </div>
                }
            })
            }
            <Dropdown.Divider />
            <Dropdown.Item eventKey="some link">some link</Dropdown.Item>
        </DropdownButton>
    )
}

export default Dropdown_tutor;